<div class="cabecalho-dashboard">

  <!-- Linha 1: Filtros compactos em linha horizontal -->
  <div class="filtros-topo">
    <p-dropdown
      [options]="contaOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="contaSelecionada"
      [placeholder]="texts.selecione_conta"
      (onChange)="onContaSelect($event)"
      styleClass="conta-dropdown">
      <ng-template pTemplate="selectedItem" let-conta>
        <div class="dropdown-conta-item" *ngIf="conta">
          <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
          <span>{{ conta.label }}</span>
        </div>
      </ng-template>
      <ng-template pTemplate="item" let-conta>
        <div class="dropdown-conta-item">
          <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
          <span>{{ conta.label }}</span>
        </div>
      </ng-template>
    </p-dropdown>

    <app-periodo-filtro
      modo="avancado"
      [valorPadrao]="'showAll'"
      [persistir]="true"
      [textoExibicao]="periodoSelecionado.texto"
      styleClass="btn-periodo"
      (periodoChanged)="onPeriodoChanged($event)">
    </app-periodo-filtro>

    <button pButton type="button"
            class="p-button-text p-button-rounded btn-refresh"
            [title]="texts.atualizar"
            (click)="onRefreshClick()">
      <i class="pi pi-refresh"></i>
    </button>
  </div>

  <!-- Linha 2: Grid de 3 KPI Cards -->
  <div class="kpi-grid">

    <!-- KPI 1: Saldo -->
    <div class="kpi-card saldo"
         [class.clicavel]="permissoes.conta"
         (click)="navegarParaTransacoes()">
      <div class="kpi-accent-bar saldo"></div>
      <div class="kpi-header">
        <div class="kpi-icon saldo">
          <i class="pi pi-wallet"></i>
        </div>
        <span class="kpi-label">{{ texts.saldo_em_conta }}</span>
      </div>
      <div class="kpi-value saldo"
           [class.positivo]="totalSaldo >= 0"
           [class.negativo]="totalSaldo < 0">
        {{ totalSaldo | currency:currencySymbol:'symbol-narrow':currencyDigits:currencyLocale }}
      </div>
      <div class="kpi-trend"
           *ngIf="periodoEhMesFechado && tendenciaSaldo"
           [class.up]="tendenciaSaldo.positivo"
           [class.down]="!tendenciaSaldo.positivo">
        <i class="pi" [class.pi-arrow-up]="tendenciaSaldo.positivo"
                       [class.pi-arrow-down]="!tendenciaSaldo.positivo"></i>
        {{ tendenciaSaldo.percentual }}% {{ texts.vs_mes_anterior }}
      </div>
      <div class="kpi-trend neutral" *ngIf="!periodoEhMesFechado">
        -- {{ texts.vs_mes_anterior }}
      </div>
    </div>

    <!-- KPI 2: Receitas -->
    <div class="kpi-card receita"
         [class.clicavel]="permissoes.receitas"
         [class.sem-permissao]="!permissoes.receitas"
         (click)="navegarParaReceitas()">
      <div class="kpi-accent-bar receita"></div>
      <div class="kpi-header">
        <div class="kpi-icon receita">
          <i class="pi pi-arrow-up"></i>
        </div>
        <span class="kpi-label">{{ texts.receita }}</span>
      </div>
      <div class="kpi-value receita">
        {{ totalReceita | currency:currencySymbol:'symbol-narrow':currencyDigits:currencyLocale }}
      </div>
      <div class="kpi-trend"
           *ngIf="periodoEhMesFechado && tendenciaReceitas"
           [class.up]="tendenciaReceitas.positivo"
           [class.down]="!tendenciaReceitas.positivo">
        <i class="pi" [class.pi-arrow-up]="tendenciaReceitas.positivo"
                       [class.pi-arrow-down]="!tendenciaReceitas.positivo"></i>
        {{ tendenciaReceitas.percentual }}% {{ texts.vs_mes_anterior }}
      </div>
      <div class="kpi-trend neutral" *ngIf="!periodoEhMesFechado">
        -- {{ texts.vs_mes_anterior }}
      </div>
    </div>

    <!-- KPI 3: Despesas -->
    <div class="kpi-card despesa"
         [class.clicavel]="permissoes.gastos"
         [class.sem-permissao]="!permissoes.gastos"
         (click)="navegarParaDespesas()">
      <div class="kpi-accent-bar despesa"></div>
      <div class="kpi-header">
        <div class="kpi-icon despesa">
          <i class="pi pi-arrow-down"></i>
        </div>
        <span class="kpi-label">{{ texts.despesa }}</span>
      </div>
      <div class="kpi-value despesa">
        {{ totalDespesa | currency:currencySymbol:'symbol-narrow':currencyDigits:currencyLocale }}
      </div>
      <div class="kpi-trend"
           *ngIf="periodoEhMesFechado && tendenciaDespesas"
           [class.up]="!tendenciaDespesas.positivo"
           [class.down]="tendenciaDespesas.positivo">
        <!-- Despesas: tendencia POSITIVA (subiu) e RUIM; tendencia NEGATIVA (desceu) e BOA -->
        <i class="pi" [class.pi-arrow-up]="tendenciaDespesas.positivo"
                       [class.pi-arrow-down]="!tendenciaDespesas.positivo"></i>
        {{ tendenciaDespesas.percentual }}% {{ texts.vs_mes_anterior }}
      </div>
      <div class="kpi-trend neutral" *ngIf="!periodoEhMesFechado">
        -- {{ texts.vs_mes_anterior }}
      </div>
    </div>

  </div>
</div>
